import { WifiXIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import PageError from "./PageError";

export const NoNetworkConnectionPageError = () => {
  const intl = useIntl();

  return (
    <PageError
      title={intl.formatMessage({
        defaultMessage: "No Internet Connection",
        description: "Heading on the no-internet connection error screen",
      })}
      subtitles={[
        intl.formatMessage({
          defaultMessage: "Check your connection and try again.",
          description:
            "Subtitle below the no-internet connection error screen heading",
        }),
      ]}
      back={{
        text: intl.formatMessage({
          defaultMessage: "Back to home",
          description: "Button to return to the home / search screen",
        }),
        options: { to: "/" },
      }}
      icon={<WifiXIcon size={60} color="#295942" />}
      hideWhatsAppButton
    />
  );
};
